import {Action} from '@ngrx/store';

export enum PatientActionTypes {
  GET_PENDINGS = '[Patient] - Get all pending questionnaires',
  GET_PENDINGS_SUCCESS = '[Patient] - Get all pending questionnaires - Success',
  GET_PENDINGS_FAILURE = '[Patient] - Get all pending questionnaires - Failure',
}

export class GetPendings implements Action {
  readonly type = PatientActionTypes.GET_PENDINGS;
}

export class GetPendingsSuccess implements Action {
  readonly type = PatientActionTypes.GET_PENDINGS_SUCCESS;
  constructor(public payload: any) {}
}

export class GetPendingsFailure implements Action {
  readonly type = PatientActionTypes.GET_PENDINGS_FAILURE;
  constructor(public payload: any) {}
}

export type AllPatientActions =
  | GetPendings
  | GetPendingsSuccess
  | GetPendingsFailure;
